import { render, staticRenderFns } from "./SwitchOrdersOTOs.vue?vue&type=template&id=8ee65102&scoped=true"
import script from "./SwitchOrdersOTOs.vue?vue&type=script&lang=js"
export * from "./SwitchOrdersOTOs.vue?vue&type=script&lang=js"
import style0 from "./SwitchOrdersOTOs.vue?vue&type=style&index=0&id=8ee65102&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ee65102",
  null
  
)

export default component.exports